import { createApi } from '@reduxjs/toolkit/query/react';
import axiosInstance from '../../services/api/axios';

import { ApiResponse } from '../../models/apiResponse.model';
import {
	ADD_ATTACHMENT,
	DELETE_ATTACHMENT,
	GET_ALL_RECRUIT_ITEMS,
} from '../../services/api/apiEndpoints';
import { AttachmentsResponse } from '../../models/responseModels.ts/attachmentsResponse.model';
import { AttachmentsPayload } from '../../models/requestModels.ts/attachments';

export const attachmentsApiSlice = createApi({
	reducerPath: 'attachmentsApiSlice',
	baseQuery: async (arg) => {
		//, api, extraOptions
		const { baseURL, ...axiosConfig } = arg;
		try {
			const response = await axiosInstance.request({
				...axiosConfig,
			});
			return { data: response.data };
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			console.error(error);
			return error?.response;
		}
	},
	tagTypes: ['attachments'],
	endpoints: (builder) => ({
		getAttachments: builder.query<
			ApiResponse<AttachmentsResponse[]>,
			{ recruitId: string; userEmail: string }
		>({
			query: (payload) => ({
				url: `${GET_ALL_RECRUIT_ITEMS}`,
				method: 'GET',
				params: {
					recruitId: payload.recruitId,
					userEmail: payload.userEmail,
				},
			}),
			providesTags: ['attachments'],
		}),
		addOrUpdateAttachments: builder.mutation<
			ApiResponse<string>,
			AttachmentsPayload
		>({
			query: (payload) => {
				const formData = new FormData();
				formData.append('fileUpload', payload.file);
				return {
					url: `${ADD_ATTACHMENT}?recruitId=${payload.recruitid.toUpperCase()}&userEmail=${payload.userEmail}`,
					method: 'POST',
					data: formData,
					headers: {
						'content-type': 'multipart/form-data',
					},
				};
			},
			invalidatesTags: ['attachments'],
		}),
		deleteAttachments: builder.mutation<ApiResponse<string>, string>({
			query: (payload) => {
				return {
					url: `${DELETE_ATTACHMENT}?itemId=${payload}`,
					method: 'Delete',
				};
			},
			invalidatesTags: ['attachments'],
		}),
	}),
});

export const {
	useAddOrUpdateAttachmentsMutation,
	useGetAttachmentsQuery,
	useDeleteAttachmentsMutation,
} = attachmentsApiSlice;
